<template>
  <div>
    <RowCard
        :theme="theme"
        style="position: relative"
    >
      <div :style="{ 'width': headers[0].width }" class="flex-center gap-4">
        <v-btn v-if="isUSP && (item.status === 'Draft' || item.status === 'Inception')" small icon @click="onEdit">
          <Iconify
              icon="material-symbols:edit"
              size="15px"
          ></Iconify>
        </v-btn>
        <v-btn small icon
               @click="onPreview">
          <Iconify
              icon="carbon:view-filled"
              size="15px"
          ></Iconify>
        </v-btn>
      </div>
      <div :style="{ 'width': headers[1].width }" :class="{ 'theme-color-seven': redText }">{{ index + 1 }}</div>
      <div :style="{ 'width': headers[2].width }" :class="{ 'theme-color-seven': redText }">{{ item.plan_master?.plan_code }}</div>
      <div :style="{ 'width': headers[3].width }" :class="{ 'theme-color-seven': redText }" class="one-line" style="height: 20px">{{ item.project_section_general_info?.project_name_th }}</div>
      <div :style="{ 'width': headers[4].width }" :class="{ 'theme-color-seven': redText }" class="one-line" style="height: 20px">{{ item.plan_master?.plan_name_th }}</div>
      <div class="one-line" style="height: 20px" :style="{ 'width': headers[5].width }" :class="{ 'theme-color-seven': redText }">
        {{ item.created_by }}
      </div>
      <div class="one-line" style="height: 20px" :style="{ 'width': headers[6].width }" :class="{ 'theme-color-seven': redText }">
        <div v-if="item.doc_type">{{ item.doc_type === 'Progress' ? '6' : '12' }} เดือน</div>
      </div>
      <div class="one-line" style="height: 20px" :style="{ 'width': headers[7].width, 'color': statusColorSeparator(item.status) }">
        {{ item.status }}
      </div>


      <v-btn
          absolute
          top
          right
          icon
          :class="{ 'rotate180': isExpanded }"
          @click="seeDetail"
      >
        <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content d-flex flex-column gap-12">
        <div class="d-flex justify-space-between">
          <div class="d-flex" style="gap: 12px">
            <div class="black--text font-type-bold" style="min-width: 125px">ชื่อโครงการ(อังกฤษ)</div>
            <div>{{ item.project_section_general_info?.project_name_en }}</div>
          </div>
          <div class="d-flex" style="gap: 12px">
            <div class="black--text font-type-bold">งบประมาณโครงการ</div>
            <div class="text-end" style="min-width: 100px">{{ formatNumber(item.budget_amount, 2) }} บาท</div>
          </div>
        </div>
        <div class="d-flex" style="gap: 12px">
          <div class="black--text font-type-bold" style="min-width: 125px">สร้างข้อเสนอ</div>
          <div>{{ toDateFormat(item.created_at) }}</div>
        </div>
        <div class="d-flex" style="gap: 12px">
          <div class="black--text font-type-bold" style="min-width: 125px">ยื่นส่งข้อเสนอ</div>
          <div>{{ toDateFormat(item.submitted1_at) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button"
import RowCard from "../components/RowCard"
import { toDateFormat, formatNumber } from "@/plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "ProgressReportItem",
  components: {
    Button,
    RowCard
  },
  props: {
    item: {
      default: () => ({})
    },
    index: {
      default: 0
    },
    headers: {
      default: () => ([])
    }
  },
  data () {
    return {
      toDateFormat,
      formatNumber,
      theme: 2,
      redText: false,
      rand: 'cl-' + Math.random().toString().slice(2),
      isExpanded: false
    }
  },
  computed: {
    ...mapState({
      isRSP: state => state.Auth.User.user_type === 'RSP',
      isUSP: state => state.Auth.User.user_type === 'USP'
    })
  },
  methods: {
    seeDetail () {
      let growDiv = document.querySelector('.' + this.rand + '.expand-layout')
      if (growDiv.clientHeight) {
        growDiv.style.height = 0
        this.isExpanded = false
      } else {
        let wrapper = document.querySelector('.' + this.rand + ' .expand-content')
        growDiv.style.height = (wrapper.clientHeight + 20) + "px"
        this.isExpanded = true
      }
    },
    onPreview() {
      this.$router.push({
        name: "FormC",
        query: { id: this.item.id, preview: true, doc_type: 'progress' },
      });
    },
    statusColorSeparator (status) {
      switch (status) {
        case 'Draft':
          this.theme = 2
          this.redText = true
          return 'var(--theme-color-seven)'

        case 'Submitted':
        case 'Submitted1':
          this.theme = 5
          return 'var(--theme-color-five)'

        case 'Rejected':
          this.theme = 4
          return 'var(--theme-color-four)'

        case 'Submitted2':
          this.theme = 10
          return 'var(--theme-color-ten)'

        case 'Approved':
        case 'Inception':
          this.theme = 3
          return 'var(--theme-color-three)'

        default:
          return 'var(--theme-color-two)'
      }
    },
    onEdit () {
      this.$router.push({ name: 'FormC', query: { id: this.item.id, doc_type: 'progress' } })
    },
    onUpdate (status) {
      this.$emit('onUpdateStatus', status)
    }
  }
}
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height .2s;
  -ms-transition: height .2s;
  -o-transition: height .2s;
  -webkit-transition: height .2s;
  transition: height .2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #FAFAFA;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>